import { Component, Input } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { RequisitionStatus } from '@core/requisitions-types';
import { BadgeComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-requisitions-status-badge',
  templateUrl: './requisitions-status-badge.component.html',
  styleUrls: ['./requisitions-status-badge.component.less'],
  imports: [BadgeComponent, TranslatePipe],
})
export class RequisitionsStatusBadgeComponent {
  @Input() public status: RequisitionStatus;
  @Input() public isArchived: boolean;
  public RequisitionStatus: typeof RequisitionStatus = RequisitionStatus;
}
